import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Stack,
  CircularProgress,
} from '@mui/material';
import { Save as SaveIcon } from '@mui/icons-material';

const SaveFilterDialog = ({
  open,
  onClose,
  editingFilterId,
  currentFilterName,
  setCurrentFilterName,
  currentFilterDescription,
  setCurrentFilterDescription,
  isFilterLoading,
  onSaveFilter,
}) => (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{editingFilterId ? 'Update Filter' : 'Save Filter'}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField
            fullWidth
            label="Filter Name"
            value={currentFilterName}
            onChange={(e) => setCurrentFilterName(e.target.value)}
            placeholder="Enter a name for this filter"
            required
          />          <TextField
            fullWidth
            label="Description (optional)"
            value={currentFilterDescription}
            onChange={(e) => setCurrentFilterDescription(e.target.value)}
            placeholder="Describe what this filter does"
            multiline
            rows={2}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={onSaveFilter}
          variant="contained"
          disabled={!currentFilterName.trim() || isFilterLoading}
          startIcon={isFilterLoading ? <CircularProgress size={16} /> : <SaveIcon />}
        >
          {editingFilterId ? 'Update' : 'Save'}
        </Button>      </DialogActions>
    </Dialog>
  );

SaveFilterDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  editingFilterId: PropTypes.string,
  currentFilterName: PropTypes.string.isRequired,
  setCurrentFilterName: PropTypes.func.isRequired,
  currentFilterDescription: PropTypes.string.isRequired,
  setCurrentFilterDescription: PropTypes.func.isRequired,
  isFilterLoading: PropTypes.bool.isRequired,
  onSaveFilter: PropTypes.func.isRequired,
};

export default SaveFilterDialog;
